export const DRAWER_TOGGLE = 'DRAWER_TOGGLE';
export const DRAWER_CLOSE = 'DRAWER_CLOSE';

export const SELECT_ITEM = 'SELECT_ITEM';
export const OPEN_EDIT = 'OPEN_EDIT';
export const CLOSE_EDIT = 'CLOSE_EDIT';
export const EDIT_TRACK = 'EDIT_TRACK';
export const OPEN_CONFIRM = 'OPEN_CONFIRM';

export const SHOW_USER_TASKS = 'SHOW_USER_TASKS';
export const SHOW_LOADER = 'SHOW_LOADER';
export const LOAD_USER_DATA = 'LOAD_USER_DATA';
export const SET_TASK_STATUS = 'SET_TASK_STATUS';
export const SAVE_TRACK_DATA = 'SAVE_TRACK_DATA';

export const SET_THEME = 'SET_THEME';
export const LOGIN = 'LOGIN';
export const DELETE_DATA = 'DELETE_DATA';
export const SAVE_DATA = 'LOAD_DATA';
export const SWITCH_THEME = 'SWITCH_THEME';
export const UPDATE_DATA = 'UPDATE_DATA';
